import {useConfigProvider} from "../../../config/ConfigProvider"
import {ExpertModel} from "../../../types"

export function expertsEndpoints() {
  const {cmsBlApiUrl, cmsBlApiApimKey, cmsBlApiFunctionKey} =
    useConfigProvider()

  const headers = {
    "Content-Type": "application/json",
    "X-Functions-Key": cmsBlApiFunctionKey || "",
    "Ocp-Apim-Subscription-Key": cmsBlApiApimKey || "",
  }

  const getExpertBioPage = async (id: string | undefined) => {
    const idParam = id ? id : ""
    const url = `${cmsBlApiUrl}/experts/page?id=${idParam}`
    return await fetch(url, {
      headers: headers,
    }).then((res) => res.json())
  }

  const getExperts = async (
    limit: number | undefined,
    skip: number | undefined,
    signal: any,
  ) => {
    const limitParam = limit ? limit : 10
    const skipParam = skip ? skip : 0
    const request = new Request(
      `${cmsBlApiUrl}/experts/list?limit=${limitParam}&skip=${skipParam}`,
      {
        headers,
        signal,
      },
    )

    const response = await fetch(request)

    if (!response.ok) {
      throw new Error("Failed to fetch experts")
    }

    return response.json() as Promise<ExpertModel[]>
  }

  const searchExperts = async (
    searchText: string | undefined,
    regions: string | undefined,
  ) => {
    const regionsParam = regions ? `region=${regions}` : ""
    const searchTextParam = searchText ? `searchTerm=${searchText}&` : ""
    const request = new Request(
      `${cmsBlApiUrl}/experts/search?${searchTextParam}${regionsParam}`,
      {
        headers,
      },
    )

    const response = await fetch(request)

    if (!response.ok) {
      throw new Error("Failed to fetch experts")
    }

    return response.json() as Promise<ExpertModel[]>
  }

  return {
    getExpertBioPage,
    getExperts,
    searchExperts,
  }
}
